import cn from 'classnames';
import ArrowIosLeft from '@crehana/icons/outline/ArrowIosLeft';
import { colors } from '@crehana/ui';
import { useTranslation } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Submenu = function Submenu(_ref) {
  var title = _ref.title,
    options = _ref.options,
    selectedValue = _ref.selectedValue,
    onSelect = _ref.onSelect,
    onBack = _ref.onBack,
    isCCSubmenu = _ref.isCCSubmenu;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col text-left",
    children: [onBack ? /*#__PURE__*/_jsxs("button", {
      type: "button",
      className: "bg-transparent focus:outline-none w-full flex items-center justify-between mb-24",
      onClick: onBack,
      "aria-label": t('BACK_LABEL'),
      children: [/*#__PURE__*/_jsx(ArrowIosLeft, {
        size: 16,
        color: colors.secondaryLight
      }), /*#__PURE__*/_jsx("span", {
        className: "font-button text-white ml-4",
        children: title
      })]
    }) : /*#__PURE__*/_jsx("span", {
      className: "font-button text-white text-left mb-24",
      children: title
    }), options.map(function (option, i) {
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        className: cn('bg-transparent focus:outline-none text-left', option.value === selectedValue ? 'font-subtitle3 text-secondary-light' : 'font-body3 text-white', {
          'mb-16': i < options.length - 1
        }),
        style: {
          lineHeight: '24px'
        },
        "aria-label": isCCSubmenu ? "".concat(title, " ").concat(option.label) : option.label,
        onClick: function onClick() {
          onSelect(option);
        },
        children: option.label
      }, "option-".concat(title, "-").concat(option.value));
    })]
  });
};
export default Submenu;